import { render, staticRenderFns } from "./BuyInStock.vue?vue&type=template&id=25d96d21"
import script from "./BuyInStock.vue?vue&type=script&lang=js"
export * from "./BuyInStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d96d21')) {
      api.createRecord('25d96d21', component.options)
    } else {
      api.reload('25d96d21', component.options)
    }
    module.hot.accept("./BuyInStock.vue?vue&type=template&id=25d96d21", function () {
      api.rerender('25d96d21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/BuyInStock.vue"
export default component.exports